"use client"
import React, { Fragment, useState, useEffect } from "react";

import { useAppData } from "@/lib/providers/AppDataProvider";

import "@/components/categories/ProfileTypeFilter.css";
import ScrollBox from "@/components/shared/ScrollBox";

const ProfileTypeFilter = ({
  className,
  scrollable,
  values,
  onChange,
  selected,
  multiple = false
}) => {
  const [entries, setEntries] = useState(null);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const { flattenedProfileTypes: profileTypes } = useAppData();

  useEffect(() => {
    // console.log("ProfileTypeFilter useEffect", values);
    if (values && values.length > 0 && profileTypes.length > 0) {
      var newEntries = [];
      values.forEach((value, index) => {
        var entry = profileTypes.find(pt => pt.value === value);
        if (entry) {
          newEntries.push(entry);
        } else if (!entry && value === "EVENT") {
          newEntries.push({
            label: "Events",
            value: "EVENT",
            type: "EVENT",
            icon: "calendar-star"
          });
        }
      });
      setEntries(newEntries);
    }
  }, [values, profileTypes]);

  const toggle = entry => {
    if (multiple) {
      var newSelected = selectedEntry ? [...selectedEntry] : [];
      var index = newSelected.findIndex(s => s === entry.value);
      if (index > -1) {
        newSelected.splice(index, 1);
      } else {
        newSelected.push(entry.value);
      }
      setSelectedEntry(newSelected);
      onChange(newSelected);
    } else {
      setSelectedEntry(entry ? entry.value : null);
      onChange(entry);
    }
  };

  useEffect(() => {
    if (selected) {
      setSelectedEntry(selected);
    }
  }, []);

  const entryClassName = entry => {
    if (multiple) {
      return selectedEntry &&
        selectedEntry.findIndex(v => v === entry.value) > -1
        ? "selected"
        : "";
    } else {
      return selectedEntry && selectedEntry === entry.value ? "selected" : "";
    }
  };

  const elements = () => {
    var theElements = !multiple
      ? [
          <span
            className={`entry ${!selectedEntry ? "selected" : ""}`}
            onClick={() => toggle(null)}
          >
            All
          </span>
        ]
      : [];
    theElements = theElements.concat(
      entries.map((entry, index) => {
        return (
          <Fragment key={index}>
            <span
              className={`entry ${entryClassName(entry)}`}
              onClick={() => toggle(entry)}
            >
              {entry.icon && <i className={`fal fa-${entry.icon}`}></i>}
              <span className="text">{entry.label}</span>
            </span>
          </Fragment>
        );
      })
    );
    return theElements;
  };

  if (!entries) return <></>;
  else {
    return (
      <div className={`profile-type-filter ${className}`}>
        {scrollable ? <ScrollBox>{elements()}</ScrollBox> : <>{elements()}</>}
      </div>
    );
  }
};
export default ProfileTypeFilter;
